import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play_audio",
  "use": "icon-play_audio-usage",
  "viewBox": "0 0 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 960 960\" id=\"icon-play_audio\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#46A0F0\" cx=\"480\" cy=\"480\" r=\"480\" /><path d=\"M700.559 477.966c1.9 1.124 1.89 2.95 0 4.068L355.44 685.966c-1.9 1.124-3.441.247-3.441-1.966V276c0-2.209 1.55-3.084 3.441-1.966L700.56 477.966Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol